// extracted by mini-css-extract-plugin
module.exports = {"container":"Recorder_container__2SfMn","wrapper":"Recorder_wrapper__1b9pe"};